module.exports = __webpack_public_path__ + "img/涉案停车管理系统.d626f705.png";